<template>
  <section :class="layoutNavbarClass">
    <div
      class="container"
      v-if="isDesktop"
    >
      <geolocation-navbar
        v-if="config.has_geolocation_access"
        :show-text="!$can('awards') "
        @click.native="openNearbyToYou()"
      />
      <engagement-navbar
        v-if="$can('engagement')"
        :show-engagement-button="showEngagementButton"
        @engagement-button-click="handleEngagementButton"
      />
      <become-partner-navbar
        v-if="!!(config || {}).has_request_partners"
        @click.native="$router.push({ name: 'Seja parceiro' })"
      />
      <profile-gtm-navbar
        ref="menu"
        @click.native="handleUser(true)"
      />
      <notification-navbar
        :has-new-notification="newNotification"
      />
    </div>

    <slot />

    <!-- User Menu -->
    <c-popover
      v-if="showMenu"
      :position="['top', 'right']"
      :target="$refs['menu']"
      @blur="showMenu = false"
    >
      <layout-menu
        v-bind="$attrs"
        v-on="$listeners"
        :items="menuItems"
        :config="config"
        :loading="loading"
        :coin="coin"
        :engagement-balance="engagement_balance"
        @close="showMenu = false"
      />
    </c-popover>

    <div class="navbar">
      <k-icon-button
        v-if="showBackButton"
        type="left1"
        class="back-button"
        @click.native="$router.back()"
      />
      <c-spinner
        v-if="isLoading"
        class="logo loading"
        size="sm"
      />
      <c-image-logo
        v-if="!isLoading && (isDesktop || config.mobile_logo)"
        :class="config.logo_no_width ? 'logo-lg' : 'logo logo-gtm'"
        data-cy="navbar-logo"
        :src="company && company.logo"
        :placeholder="placeholder"
        :alt="config.title"
        @click.native="handleRouteHome"
      />
      <section class="actions">
        <div class="right-side">
          <geolocation-navbar
            v-if="!isDesktop && config.has_geolocation_access"
            class="button"
            @click.native="openNearbyToYou()"
          />
          <c-button
            size="lg"
            icon="search"
            class="button search"
            icon-size="17"
            @click="search($event)"
          />
          <notification-navbar
            :has-new-notification="newNotification"
            @click.native="$emit('toggleNotifications')"
          />
          <c-button
            class="button profile"
            size="lg"
            icon="menu"
            @click="handleUser"
          />
        </div>
      </section>
    </div>

    <c-tabber
      v-if="!isDesktop && $can('engagement')"
      class="toggler"
      :tabs="tabs"
      :active-tab="activeTab"
      @change-tab="tab => handleSubmit(tab)"
    />
  </section>
</template>

<script>
import { KIconButton } from 'kaledo-components'
import LayoutMenu from '@components/Layout/LayoutMenu'
import GeolocationNavbar from './Navbar/GeolocationNavbar.vue'
import EngagementNavbar from './Navbar/EngagementNavbar.vue'
import BecomePartnerNavbar from './Navbar/BecomePartnerNavbar.vue'
import ProfileGtmNavbar from './Navbar/ProfileGtmNavbar.vue'
import NotificationNavbar from './Navbar/NotificationNavbar.vue'
import CImageLogo from '@components/CComponents/CImageLogo.vue'
import {
  IS_FETCHING_CAMPAIGNS,
  USER,
  SEARCH_TERM_CLEAR,
  CHECK_NOTIFICATIONS,
  NEW_NOTIFICATIONS,
  COIN,
  GET_COIN,
  ENGAGEMENT_BALANCE
} from '@store/types'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    GeolocationNavbar,
    EngagementNavbar,
    BecomePartnerNavbar,
    ProfileGtmNavbar,
    NotificationNavbar,
    KIconButton,
    CImageLogo,
    LayoutMenu
  },

  props: {
    menuItems: Array,
    isLoading: Boolean,
    company: Object,
    config: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      showMenu: false,
      scroll: 0,
      placeholder: require('@/assets/img/campaign-placeholder.svg'),
      tabs: [
        {
          name: 'Descontos',
          value: 'Home',
          icon: 'cash-banknote-percent'
        },
        {
          name: 'Recompensas',
          value: 'Recompensas',
          icon: 'star-favorite'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: USER,
      newNotification: NEW_NOTIFICATIONS,
      coin: COIN,
      engagement_balance: ENGAGEMENT_BALANCE
    }),

    activeTab () {
      return this.$route.path.includes('recompensas') ? 'Recompensas' : 'Home'
    },

    showHomeSearchButton () {
      return !this.isDesktop && !this.config.mobile_logo && this.$route.name === 'Home'
    },

    showEngagementButton () {
      const routesNotAllowed = ['Recompensas', 'Resgate de Recompensas']
      return !routesNotAllowed.includes(this.$route.name)
    },

    showBackButton () {
      return (!this.isDesktop && this.$route.name !== 'Home' && this.showEngagementButton)
    },

    layoutNavbarClass () {
      return this.isDesktop || !this.$can('engagement') ? 'layout-navbar' : 'layout-navbar  layout-navbar-mobile'
    }
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.checkScroll)
  },

  mounted () {
    this.chekNotifications()
    this.checkScroll()
    window.addEventListener('scroll', this.checkScroll)
  },

  methods: {
    ...mapMutations({
      setFetchingCampaigns: IS_FETCHING_CAMPAIGNS,
      clearTerm: SEARCH_TERM_CLEAR
    }),
    ...mapActions({
      getUser: USER,
      chekNotifications: CHECK_NOTIFICATIONS,
      getCoin: GET_COIN
    }),

    openNearbyToYou () {
      if (this.$route.name !== 'Próximos a você') this.$router.push({ name: 'Próximos a você' })
    },

    search (event) {
      event && event.target && event.target.blur()
      this.$emit('search')
    },
    checkScroll () {
      this.scroll = window.scrollY // this.$el.getBoundingClientRect()
      if (!this.scroll) this.showMenu = false
    },

    handleRouteHome () {
      this.clearTerm()
      this.setFetchingCampaigns(false)
      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
      }
    },
    handleSubmit (name) {
      if (this.$route.name === name) return
      if (name === 'Recompensas') {
        window.dataLayer.push({
          event: 'pontos-home',
          company_slug: this.config.slug
        })
      }
      this.$router.push({ name })
    },
    handleEngagementButton () {
      window.dataLayer.push({
        event: 'pontos-home',
        company_slug: this.config.slug
      })
      this.$router.push({ name: 'Recompensas' })
    },

    async handleUser (isMobileButton) {
      this.loading = true
      if (!this.user.id) { await this.getUser() }
      if (this.$can('engagement') && (!this.coin.program_name || !this.coin.program_image)) { await this.getCoin() }
      if (isMobileButton === true) {
        this.showMenu = !this.showMenu
      } else {
        this.$emit('toggle', 'Profile')
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/reference';
.layout-navbar-mobile {
  flex-direction: column !important;
  height: 105px !important;
}
.layout-navbar {
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 70px;
  padding: 10px;
  .container {
    display: flex;
    justify-content: space-between;
  }
  .search-button {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    border: none;
    border-radius: 99px;
    background-color: $search-input-color;
    color: $disabled-font;
    overflow: hidden;
    .search-icon {
      margin-right: 8px;
    }
    .text {
      white-space: nowrap;
    }

    @media only screen and (max-width: 359px) {
      width: 190px;
      position: relative;
      .text {
        position: absolute;
        left: 34px;
      }
     }
    @media only screen and (max-width: 280px) {
      width: 150px;
    }

  }
  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .logo {
    max-height: 40px;
    max-width: 140px;
    margin-left: 10px;
    cursor: pointer;

    @include mobile {
      margin: 0 auto;
    }
  }

  .logo-lg {
    max-height: 40px;
    margin-left: 10px;
    cursor: pointer;

    @include mobile {
      max-width: 140px;
      margin: 0 auto;
    }
  }

  @include desktop {
    @include container;
    flex-direction: row-reverse;

    & > .search {
      margin: {
        top: -10px;
        bottom: -10px;
      }
    }

    .actions {
      display: none !important;
      margin-right: 10px;
    }
  }
  .back-button {
    min-width: 48px;
    margin-right: 10px;
  }
  .actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left-side {
      width: 100%;
    }
    .right-side {
      width: 100%;
      display: flex;
      justify-content: flex-end;

      & > .button { margin-left: 10px; }
    }
  }
  & > .toggler {
    width: 106%;
    height: 60px;
    &  > .tab {
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 18px;
      padding: 35px 5px 8px;
      text-align: center;
      letter-spacing: -0.121905px;
      text-transform: capitalize;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: nowrap !important;
      & > .icon {
        margin-bottom: 5px !important;
      }
    }
  }

}

.layout-navbar-button-fade {
  @at-root {
    #{&}-enter-active,
    #{&}-leave-active {
      transition: opacity .3s ease !important;
    }
    #{&}-enter,
    #{&}-leave-to {
      opacity: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/LayoutNavbar.vue